import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { LegalInformation } from './components/legal-information/legal-information';
import { Commands } from './services/commands/commands';
import { Events } from "./services/events/events";
import { playerConnectionGuard } from './guards/player-connection/player-connection-guard';

import { WaitingRoom as MindLinkWaitingRoom } from './games/mind-link/components/waiting-room/waiting-room';
import { LeaderBoard as MindLinkLeaderBoard } from './games/mind-link/components/leader-board/leader-board';
import { PrompterBoard as MindLinkPrompterBoard } from './games/mind-link/components/prompter-board/prompter-board';
import { About as MindLinkAbout } from "./games/mind-link/components/about/about";

import { WaitingRoom as ImpostorWaitingRoom } from './games/impostor/components/waiting-room/waiting-room';
import { Board as ImpostorBoard } from './games/impostor/components/board/board';

import { Commands as MindLinkCommands } from './games/mind-link/services/commands/commands';
import { Events as MindLinkEvents } from "./games/mind-link/services/events/events";

import { Commands as ImpostorCommands } from './games/impostor/services/commands/commands';
import { Events as ImpostorEvents } from './games/impostor/services/events/events';

export const routes: Routes = [
    
    // MIND LINK

    {
        path: 'mind-link',
        providers: [
            { provide: Commands, useExisting: MindLinkCommands },
            { provide: Events, useExisting: MindLinkEvents }
        ],
        children: [
            { path: '', redirectTo: 'waiting-room', pathMatch: 'full' },
            { path: 'waiting-room', component: MindLinkWaitingRoom, title: 'Mind Link - Ludico' },
            { path: 'waiting-room/:room_id', component: MindLinkWaitingRoom, title: 'Mind Link - Ludico' },
            { path: 'leader-board/:room_id', component: MindLinkLeaderBoard, title: 'Mind Link - Ludico', canActivate: [playerConnectionGuard] },
            { path: 'prompter-board/:room_id', component: MindLinkPrompterBoard, title: 'Mind Link - Ludico', canActivate: [playerConnectionGuard] },
            { path: 'about', component: MindLinkAbout,  title: 'Mind Link - About' }
        ]
    },

    // IMPOSTOR

    {
        path: 'impostor',
        providers: [
            { provide: Commands, useExisting: ImpostorCommands },
            { provide: Events, useExisting: ImpostorEvents }
        ],
        children: [
            { path: '', redirectTo: 'waiting-room', pathMatch: 'full' },
            { path: 'waiting-room', component: ImpostorWaitingRoom, title: 'Impostor - Ludico' },
            { path: 'waiting-room/:room_id', component: ImpostorWaitingRoom, title: 'Impostor - Ludico' },
            { path: 'board/:room_id', component: ImpostorBoard, title: 'Impostor - Ludico', canActivate: [playerConnectionGuard] }
        ]
    },

    // FAST ROOMS ACCESSES

    { path: 'ml/:room_id', redirectTo: 'mind-link/waiting-room/:room_id', pathMatch: 'full' },
    { path: 'im/:room_id', redirectTo: 'impostor/waiting-room/:room_id', pathMatch: 'full'},
    
    // GLOBAL

    { path: '', component: Home, title: 'Ludico' },
    { path: 'legal-information', component: LegalInformation, title: 'Legal Information - Ludico' },
    
    { path: '**', redirectTo: '' }

];
